/**
 * WiringSummaryCards Component
 *
 * Summary statistics cards for the wiring report.
 */

import React from 'react';
import { Cable, GitBranch, Circle } from 'lucide-react';
import { ReportSummaryCard, ReportSummaryGrid } from '../primitives/ReportSummaryCard';
import type { WiringReportSummary } from '@/types/reports';

interface WiringSummaryCardsProps {
  summary: WiringReportSummary;
}

export function WiringSummaryCards({ summary }: WiringSummaryCardsProps) {
  // Format length with unit - handle multiple units if mixed
  const formatLength = () => {
    const units = Object.keys(summary.lengthByUnit);
    if (units.length === 0) return { value: 0, unit: summary.primaryUnit };
    if (units.length === 1) {
      return {
        value: summary.lengthByUnit[units[0]],
        unit: units[0],
      };
    }
    // Multiple units - show primary
    return {
      value: summary.totalCableLength,
      unit: `${summary.primaryUnit}*`,
    };
  };

  const lengthDisplay = formatLength();

  return (
    <ReportSummaryGrid>
      <ReportSummaryCard
        label="Total Cable Length"
        value={Math.round(lengthDisplay.value * 10) / 10}
        unit={lengthDisplay.unit}
        icon={Cable}
        description={
          Object.keys(summary.lengthByUnit).length > 1
            ? 'Mixed units in project'
            : undefined
        }
      />
      <ReportSummaryCard
        label="Cable Paths"
        value={summary.totalPaths}
        icon={GitBranch}
      />
      <ReportSummaryCard
        label="Junction Boxes"
        value={summary.totalJunctions}
        icon={Circle}
      />
    </ReportSummaryGrid>
  );
}
